import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { PairTickers, PairTrend } from '@root/entities/pair/ui'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
}

export const LimitOrderPrices: React.FC<Props> = ({ pair }) => {
  const [priceChange] = useAtom(pair.stats['1D'].priceChange)
  const [price] = useAtom(pair.price)

  return (
    <Root>
      <Tickers>
        <PairTickers
          quote={pair.quote}
          base={pair.base}
          premiumInfo={pair.premiumInfo}
        />
        <PairTrend showPercents changePercents={priceChange.toNumber()} />
      </Tickers>
      <Price>
        <Numeric
          value={price.priceNative}
          preset="currency-amount-short"
          currency={pair.base.ticker}
        />
      </Price>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
`

const Price = styled.div`
  display: grid;
  justify-content: start;

  color: var(--text-12);
  text-align: right;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;

  white-space: nowrap;
`

const Tickers = styled.div`
  display: grid;
  justify-content: start;
  grid-template-columns: auto auto;
  gap: 4px;

  height: 14px;
`
